export default __webpack_public_path__ + "fd272b9e3ca9b73890cb10bfb0b74329.ttf";